import React from "react";
import { Button } from '@chakra-ui/react';
import { Link } from "react-router-dom";

function CustomButton(props) {
  const buttonStyles = {
    width: props.width || "375px",
    height: props.height || "46px",
    flexShrink: 0,
    borderRadius: "16px",
    background: props.backgroundColor || "#80BCB0",
    boxShadow: `0px 4px 0px 0px ${props.boxShadowColor || "#6D9D96"}`,
    border: props.stroke || "none", // Agregar stroke si se proporciona la prop
    
  };

  const textStyle = {
    color: props.textColor || "#FFF",
    textAlign: "center",
    fontFamily: "Arial",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "18px",
    letterSpacing: "0.8px",
    textTransform: "uppercase",
  };

  return (
    <Link to={props.to}>
      <Button
        style={buttonStyles}
        onClick={props.onClick}
      >
        <div style={textStyle}>
          {props.text}
        </div>
      </Button>
    </Link>
  
  );
}

export default CustomButton;
